module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-template __base",
    attrs: {
      "id": ("wrapper-product_sku__" + (_vm.product.sku))
    }
  }, [(_vm.product) ? _c('product-detail', {
    attrs: {
      "title": _vm.title,
      "product": _vm.product
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a11eced", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a11eced","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/products/base.vue
// module id = 741
// module chunks = 1